import { GetLeadsFilters } from "@/api/lead-api.js";
import { validateRange } from "../../../helpers/rangeNumber";
import { DEFAULT_PHASES } from "../../../constants/phases";

const DEFAULT_FILTERS = {
  type: "active"
  //get: ["active", "in-operation", "finished"]
};
export default {
  namespaced: true,
  state: {
    filtersSelectedChanged: false,
    filtersSelected: { ...DEFAULT_FILTERS },
    filterSomeFilterSelected: false,
    filterShowLeadsDuplicates: false,
    filterShowDiscarded: false,
    filterShowDiscardedTmp: false,
    filterShowDiscardedAndActive: false,
    filterShowDiscardedAndActiveTmp: false,
    filterShowDelayedLeads: false,
    filterShowDelayedLeadsTmp: false,
    filterInitDateCreateAt: "",
    filterEndDateCreateAt: "",
    filterProfiles: "",
    filterBrokers: "",
    filterBrex: "",
    filterZones: [],
    filterText: "",
    filterLeadStatus: "",
    filterHowDidContactUs: [],
    filterWhereDidContactUs: [],
    filterCampaign: "",
    filterConjunto: "",
    filterAnuncio: "",
    filterFormulario: "",
    clearFilters: false,
    filters: null, // lista de todos los filtros, es muy usado en varias partes del sistema, para datos customizados
    loadingFilters: false, // usar para controlar si los filtros ya cargaron o no,
    showReassigned: false,
    typeRegister: undefined, // tipo de registro que se esta realizando (manual | automatic),
    customFields: {},
    filterCategory: undefined
  },
  getters: {
    // recupera las fases que estan en filters y si no hay devuele un array de fases por
    // defecto
    getPhases(state) {
      return state.filters?.phases || DEFAULT_PHASES;
    },
    getSources(state) {
      return state.filters?.sources?.map(s => s.source) || [];
    },
    getMediums(state) {
      return state.filters?.mediums?.map(medium => medium.medium) || [];
    },
    getZones(state) {
      return state.filters?.zones || [];
    }
  },
  mutations: {
    setFiltersSelectedChanged(state, value) {
      state.filtersSelectedChanged = value;
    },
    setFiltersSelected(state, values) {
      state.filtersSelected = values;
    },
    setFilters(state, filters) {
      state.filters = filters;
    },
    setLoadingFilters(state, value) {
      state.loadingFilters = value;
    },
    setClearFilters(state, value) {
      state.clearFilters = value;
    },
    setfilterSomeFilterSelected(state, value) {
      state.filterSomeFilterSelected = value;
    },
    setfilterShowLeadsDuplicates(state, value) {
      state.filterSomeFilterSelected = value;
      state.filterShowLeadsDuplicates = value;
    },
    setFilterShowDiscarded(state, value) {
      state.filterLeadStatus = value ? "" : state.filterLeadStatus;
      state.filterSomeFilterSelected = value;
      state.filterShowDiscardedAndActive = false;
      state.filterShowDiscarded = value;
      //
      setFilterPhases(state);
    },
    setFilterShowDiscardedAndActive(state, value) {
      state.filterLeadStatus = value ? "" : state.filterLeadStatus;
      state.filterSomeFilterSelected = value;
      state.filterShowDiscarded = false;
      state.filterShowDiscardedAndActive = value;

      //
      setFilterPhases(state);
    },
    setFilterShowDelayed(state, value) {
      state.filterSomeFilterSelected = value;
      state.filterShowDelayedLeads = value;
      //
      //Se muestran solo los vencido, pero esta pendiente
      state.filterShowDelayedLeadsTmp = value;
      state.filtersSelectedChanged = value;
      if (value) state.filtersSelected.leadPostponed = value;

      if (!state.filterShowDelayedLeads && state.filterShowDelayedLeadsTmp) {
        state.filterShowDelayedLeadsTmp = false;
        state.filtersSelectedChanged = true;
      }
    },
    setFilterInitDateCreateAt(state, value) {
      state.filterSomeFilterSelected = value ? true : false;
      state.filterInitDateCreateAt = value;
      //
      //Se añade el filtro de fecha de inicio
      state.filtersSelectedChanged = true;
      state.filtersSelected.date = {
        ...state.filtersSelected.date,
        start: state.filterInitDateCreateAt || undefined
      };

      if (!state.filterEndDateCreateAt && !state.filterInitDateCreateAt) {
        delete state.filtersSelected.date;
      }
    },
    setFilterEndDateCreateAt(state, value) {
      state.filterSomeFilterSelected = value ? true : false;
      state.filterEndDateCreateAt = value;
      //
      //Se añade el filtro de fecha de final
      state.filtersSelectedChanged = true;
      state.filtersSelected.date = {
        ...state.filtersSelected.date,
        end: state.filterEndDateCreateAt || undefined
      };
      if (!state.filterEndDateCreateAt && !state.filterInitDateCreateAt) {
        delete state.filtersSelected.date;
      }
    },
    setFilterProfiles(state, value) {
      state.filterSomeFilterSelected = value ? true : false;
      state.filterProfiles = value;
      //
      //Se añade el filtro de perfil: a,b,c,d
      state.filtersSelectedChanged = true;
      state.filtersSelected.profile = state.filterProfiles.toUpperCase();
    },
    setFilterBrokers(state, value) {
      state.filterSomeFilterSelected = value ? true : false;
      state.filterBrokers = value;
      //
      state.filtersSelectedChanged = true;
      state.filtersSelected.contactId =
        state.filterBrokers === "all" ? undefined : state.filterBrokers;
    },
    setFilterBrex(state, value) {
      state.filterSomeFilterSelected = value ? true : false;
      state.filterBrex = value;
      //
      state.filtersSelectedChanged = true;
      state.filtersSelected.contact_external_broker_id = state.filterBrex;
    },
    setFilterLeadStatus(state, value) {
      state.filterSomeFilterSelected = value ? true : false;
      state.filterLeadStatus = value;
      //
      state.filtersSelectedChanged = true;
      if (value) {
        switch (state.filterLeadStatus?.phase) {
          case "active":
            state.filtersSelected.type = state.filterLeadStatus.tracking_phase;
            delete state.filtersSelected.get;
            break;
          case "in-operation":
            state.filtersSelected.type = state.filterLeadStatus.operation_phase;
            delete state.filtersSelected.get;
            break;
          default:
            state.filtersSelected.type = state.filterLeadStatus?.phase;
            delete state.filtersSelected.get;
            break;
        }
      } else {
        // Restaurar filtro por defecto cuando no hay selección específica
        state.filtersSelected = {
          ...state.filtersSelected,
          ...DEFAULT_FILTERS
        };
      }
    },
    setFilterHowDidContactUs(state, value) {
      state.filterSomeFilterSelected = value ? true : false;
      state.filterHowDidContactUs = value;
      //
      //Se añade el filtro por source
      state.filtersSelectedChanged = true;
      const falsySource =
        !value || (Array.isArray(value) && value.length === 0);
      const falsyMedium =
        !state.filterWhereDidContactUs ||
        (Array.isArray(state.filterWhereDidContactUs) &&
          state.filterWhereDidContactUs.length === 0);

      if (falsySource) {
        if (falsyMedium) state.filtersSelected.traffic = undefined;
        if (state.filtersSelected.traffic)
          state.filtersSelected.traffic.source = undefined;

        return;
      }
      if (state.filtersSelected.traffic) {
        state.filtersSelected.traffic.source = state.filterHowDidContactUs.map(
          a => a._id
        );
      } else {
        state.filtersSelected.traffic = {
          source: state.filterHowDidContactUs.map(a => a._id)
        };
      }
    },
    setFilterWhereDidContactUs(state, value) {
      state.filterSomeFilterSelected = value ? true : false;
      state.filterWhereDidContactUs = value;
      //
      state.filtersSelectedChanged = true;
      const falsyMedium =
        !value || (Array.isArray(value) && value.length === 0);
      const falsySource =
        !state.filterHowDidContactUs ||
        (Array.isArray(state.filterHowDidContactUs) &&
          state.filterHowDidContactUs.length === 0);

      if (falsyMedium) {
        if (falsySource) state.filtersSelected.traffic = undefined;
        if (state.filtersSelected.traffic)
          state.filtersSelected.traffic.medium = undefined;

        return;
      }

      if (!value || (Array.isArray(value) && value.length === 0)) {
        if (state.filtersSelected.traffic)
          state.filtersSelected.traffic.medium = undefined;
        return;
      }
      if (state.filtersSelected.traffic) {
        state.filtersSelected.traffic.medium = state.filterWhereDidContactUs.map(
          a => a._id
        );
      } else {
        state.filtersSelected.traffic = {
          medium: state.filterWhereDidContactUs.map(a => a._id)
        };
      }
    },
    setFilterText(state, value) {
      state.filterSomeFilterSelected = value ? true : false;
      state.filterText = value;
    },
    setFilterZones(state, value) {
      state.filterSomeFilterSelected = value ? true : false;
      state.filterZones = value;
      //
      //Se añade el filtro por zones
      state.filtersSelectedChanged = true;
      state.filtersSelected.zones = state.filterZones;
    },
    setFilterCampaign(state, value) {
      state.filterSomeFilterSelected = value ? true : false;
      state.filterCampaign = value;
      //
      //Se añade el filtro de mkt campaña
      state.filtersSelectedChanged = true;
      if (state.filtersSelected.mkt) {
        state.filtersSelected.mkt.campaign = state.filterCampaign;
      } else {
        state.filtersSelected.mkt = {
          campaign: state.filterCampaign
        };
      }
    },
    setFilterConjunto(state, value) {
      state.filterSomeFilterSelected = value ? true : false;
      state.filterConjunto = value;
      //
      //Se añade el filtro de mkt conjunto
      state.filtersSelectedChanged = true;
      if (state.filtersSelected.mkt) {
        state.filtersSelected.mkt.adSet = state.filterConjunto;
      } else {
        state.filtersSelected.mkt = {
          adSet: state.filterConjunto
        };
      }
    },
    setFilterAnuncio(state, value) {
      state.filterSomeFilterSelected = value ? true : false;
      state.filterAnuncio = value;
      //
      //Se añade el filtro de mkt anuncio
      state.filtersSelectedChanged = true;
      if (state.filtersSelected.mkt) {
        state.filtersSelected.mkt.ad = state.filterAnuncio;
      } else {
        state.filtersSelected.mkt = {
          ad: state.filterAnuncio
        };
      }
    },
    setFilterFormulario(state, value) {
      state.filterSomeFilterSelected = value ? true : false;
      state.filterFormulario = value;
      //
      //Se añade el filtro de mkt formulario
      state.filtersSelectedChanged = true;
      if (state.filtersSelected.mkt) {
        state.filtersSelected.mkt.form = state.filterFormulario;
      } else {
        state.filtersSelected.mkt = {
          form: state.filterFormulario
        };
      }
    },
    setShowReassigned(state, value) {
      state.showReassigned = value;
      state.filterSomeFilterSelected = !!value;
      //
      state.filtersSelected.reassigned = true;
      state.filtersSelectedChanged = true;
    },
    setTypeRegister(state, value) {
      state.typeRegister = value;
      state.filterSomeFilterSelected = !!value;
      //
      state.filtersSelected.registration = state.typeRegister;
      state.filtersSelectedChanged = true;
    },
    setTypeLanguage(state, value) {
      state.typeLanguage = value;
      state.filterSomeFilterSelected = !!value;
      //

      state.filtersSelected.language = state.typeLanguage;
      state.filtersSelectedChanged = true;
    },
    setCustomFields(state, value) {
      // extrae los campos validos
      const validCustomFields = validateCustomFields({
        ...state.customFields,
        ...value
      });

      const someFilterSelected = validCustomFields.length > 0;

      state.customFields = someFilterSelected
        ? Object.fromEntries(validCustomFields)
        : undefined;

      // actualiza el estado de los filtros
      state.filterSomeFilterSelected = someFilterSelected;
      state.filtersSelected.custom_fields = state.customFields;
      state.filtersSelectedChanged = true;
    },
    setFilterCategory(state, value) {
      state.filterCategory = value;
      state.filterSomeFilterSelected = !!value;
      state.filtersSelected.category = value;
      state.filtersSelectedChanged = true;
    }
  },
  actions: {
    fetchGetLeadsFilters({ commit }) {
      try {
        commit("setLoadingFilters", true);
        return new Promise(resolve => {
          GetLeadsFilters()
            .then(res => {
              commit("setFilters", res.filters);
              const sources = res.filters.sources.map(({ source }) => source);
              const mediums = res.filters.mediums.map(({ medium }) => medium);
              commit("traffics/setSources", sources, { root: true });
              commit("traffics/setMediums", mediums, { root: true });
              commit("setLoadingFilters", false);
              resolve(res.filters);
            })
            .catch(err => {
              throw new Error(err);
            })
            .finally(() => {
              commit("setLoadingFilters", false);
            });
        });
      } catch (err) {
        return Promise.reject(err);
      }
    },
    updateCustomFields({ commit }, { key, value }) {
      commit("setCustomFields", { [key]: value });
    }
  }
};

function setFilterPhases(state) {
  if (state.filterShowDiscardedAndActive) {
    //Se añade el filtro de mostrar todos
    state.filtersSelectedChanged = true;
    state.filterShowDiscardedAndActiveTmp = true;
    if (state.filterLeadStatus) {
      state.filterLeadStatus = "";
      delete state.filtersSelected["type"];
      state.filtersSelected.type = "phase";
      state.filtersSelected.get = [
        "active",
        "in-operation",
        "finished",
        "discarded"
      ];
    } else {
      state.filtersSelected.type = "phase";
      state.filtersSelected.get = [
        "active",
        "in-operation",
        "finished",
        "discarded"
      ];
    }
  }
  if (
    !state.filterShowDiscardedAndActive &&
    state.filterShowDiscardedAndActiveTmp
  ) {
    state.filtersSelectedChanged = true;
    state.filterShowDiscardedAndActive = false;
    // Restaurar filtro por defecto
    state.filtersSelected = { ...state.filtersSelected, ...DEFAULT_FILTERS };
  }

  if (state.filterShowDiscarded) {
    //Se añade el filtro de mostrar solo descartados
    state.filtersSelectedChanged = true;
    state.filterShowDiscardedTmp = true;
    if (state.filterLeadStatus) {
      state.filterLeadStatus = "";
    }
    state.filtersSelected.type = "discarded";
    delete state.filtersSelected.get;
  }
  if (!state.filterShowDiscarded && state.filterShowDiscardedTmp) {
    state.filtersSelectedChanged = true;
    state.filterShowDiscardedTmp = false;
    // Restaurar filtro por defecto
    state.filtersSelected = { ...state.filtersSelected, ...DEFAULT_FILTERS };
  }
}

function validateCustomFields(customFields) {
  const someFilterSelected = Object.entries(customFields).filter(
    ([, value]) => {
      // es un valor falsy
      if (!value) return false;
      if (typeof value === "object") {
        return Array.isArray(value) ? value.length > 0 : validateRange(value);
      }
      return true;
    }
  );
  return someFilterSelected;
}
